import { SerapeBand } from './Serape';

// Colorful talavera tile strip — replaces the old scrolling marquee.
export const TileStrip = () => (
  <div data-testid="tile-strip" aria-hidden="true">
    <SerapeBand />
    <div className="tile-talavera h-24 sm:h-28" />
    <SerapeBand />
  </div>
);
